import { SPACES } from '@belong/themes';
import { ITestable, GutterBreakpointKey, TBreakpointKeys } from '@belong/types';

export interface ICarouselProps extends ITestable {
  /**
   * Children of the component
   */
  children: React.ReactNode[];

  /**
   * Initial slide index
   */
  initialSlide?: number;
}

export interface ITransitionProps {
  property: string;
  ease: string;
  duration: number;
}

export type TControlAction = 'decrease' | 'increase';

export const SLIDE_GUTTERS: Record<GutterBreakpointKey, number> = {
  xs: SPACES.xsmall,
  md: SPACES.large,
  lg: SPACES.xlarge
} as const;

export const CONTROL_MARGIN_BOTTOM: Record<GutterBreakpointKey, string> = {
  xs: '12.2rem',
  md: '11rem',
  lg: '11rem'
} as const;

export const OFFSET_CONTROL_AMOUNT: Record<TBreakpointKeys, number> = {
  xs: 0.4,
  sm: 0.4,
  md: 0,
  lg: 0,
  xl: 0
} as const;
